/*
 * @Author: flybird
 * @Date: 2021-06-04 13:20:21
 * @LastEditTime: 2021-12-19 12:47:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: src/config/config/init.config.js
 */
import Vue from 'vue';
// // import R3 from '@syman/burgeon-r3';
import '@/assets/css/custom.less'; // 框架 主题文件（变量）

// import cus from 'burgeonConfig'
// import pageNote from '@/config/config/pageNote'

import qs from 'qs';
const i18n = $i18n
import service from '@/service/index.js';
import store from '@/config/store/store'; // 将老框架公共状态注册为customize模块

import proVersion from './package.json';
import BC from "./src/component/omsui";

const { SyncHook } = require('tapable')

Vue.prototype.myHook = {
  'asyncTask': new SyncHook()
}
Vue.prototype.myHook.asyncTask.tap('asyncTask', () => {
  window.dispatchEvent(new CustomEvent('addTask', {
    detail: {
      type: 'notice',
    },
  }))
})

const { components } = R3
Vue.component('WaterMark', components.WaterMark)
class InitAppConfig {
  constructor() {
    // -------------引入框架项目配置文件;
    let pageNote = require('@/config/config/pageNote').default;
    window.$store = store;
    window.$pageNote = pageNote;
    window.$BC = BC
    // console.log(i18n);
    window.$it = (str) => {
      return i18n.t(str)
    }
    window.oss = "https://r3standard-zjk-oss.oss-cn-zhangjiakou.aliyuncs.com"
    Vue.prototype.oss = "https://r3standard-zjk-oss.oss-cn-zhangjiakou.aliyuncs.com"
    Vue.prototype.qs = qs;
    Vue.prototype.$BC = BC
    Vue.prototype.axios = $BC.Utils.request;
    Vue.prototype.$lodash = window._;
    Vue.prototype.service = service;
    window.$service = service
    Vue.prototype.vmI18n = i18n; // 暂时留着, for 组件库
    // Vue.prototype.$t = i18n.t.bind(i18n)
    Vue.prototype.$it = (str) => {
      return i18n.t(str)
    }

    let cus = require('@/config').default;
    window.OMS = cus;

    window.version = {
      '@syman/burgeon-r3': R3.version,
      '@syman/ark-ui': window.Ark.version,
      '@syman/ark-ui-bcl': window.$Bcl.version,
    }

    OMS.cssHandleUtils.browserCssCompatible()

    // 路由守卫 去掉部分定制界面onresize方法
    R3.router.afterEach(to => {
      const tableNameArr = ['ORDERMANAGER', 'PAYABLEADJUSTMENTLIST', 'returnGoodList', 'manualMatching', 'RETURNSTOREAGELIST', 'PROMACTIQUERYLIST', 'SETWAREHOUSELOGISTICS'];
      const currentTable = to.params.tableName || to.params.customizedModuleName;
      if (!tableNameArr.includes(currentTable)) {
        // window.onresize = null;
        // 销毁resize方法
        $utils.removeOnresize();
      }

      // 店铺策略-默认退货仓库pop定位
      OMS.cssHandleUtils.CP_C_WAREHOUSE_DEF_ID_PoperPosition(currentTable)
    });

    // 存储可视化宽度
    let clientWidthsFun = () => {
      let clientWidths = document.body.clientWidth;
      if (clientWidths < 990) { $store.commit('customize/colRowNum', 3); } else { $store.commit('customize/colRowNum', 4); }
    };
    clientWidthsFun();
    // 屏幕变化
    window.addEventListener('resize', () => {
      clientWidthsFun();
      console.log('index resize')
      OMS.cssHandleUtils.refreshAgTableHeight() // 渲染定制列表页面ag表格
    }, false)
    // window.onresize = () => {
    //   clientWidthsFun();
    //   console.log('index resize')
    //   OMS.cssHandleUtils.refreshAgTableHeight() // 渲染定制列表页面ag表格
    // }
    window.addEventListener("routeTo", ({ detail }) => {
      const { info, conf } = detail
      if (info.tableName.toUpperCase() == "BI_QLIKSENS") {
        conf.abort = true // 中断执行R3原逻辑
        window.open(`${window.location.protocol}//${window.location.hostname}:45555`);
      }
    }, false);
  }
}

export default new InitAppConfig();
// export default {}
